module.exports = __webpack_public_path__ + "img/b200.b571a8a6.jpg";